<template>
  <div class="p-4 rounded-xl border-[1px] border-[#23D59F80] bg-[#F6FEF9] relative">
    <div class="flex items-center justify-between">
      <div class="w-full text-left">
        <span class="text-[18px] font-semibold text-[#5A5A5A]">{{ displayCurrencyNoDecimals(currentSavings) }}</span>
        <span class="text-[12px] text-[#5A5A5A] ml-2">/ {{ displayCurrencyNoDecimals(savingsGoal) }}</span>

        <div class="relative h-2 w-full overflow-hidden rounded-full bg-grey-light-200 my-3">
          <div class="h-full bg-[#23d59f] transition-all" :style="{ width: `${progress}%` }" />
        </div>
        <p class="text-base font-[14px] text-grey-light-600">
          Total amount: {{ displayCurrencyNoDecimals(totalAmount) }}
        </p>
      </div>
      <div class="relative w-[100px] h-[100px] flex items-center justify-center">
        <img :src="badgeIcon" class="absolute inset-0 w-[90px] h-[107px] object-contain" />
        <div
          class="relative flex flex-col items-center font-bold text-white"
          :class="{ 'top-[-10px]': !minimumThresholdMet }"
        >
          <span class="text-[13px] font-[900]">{{ displayCurrencyNoDecimals(displayReward) }}</span>
          <span class="text-[9px] font-[600]">Reward</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import AchievedRewardBadge from '@/assets/shopper/achieved-reward-badge.svg';
import NoRewardBadge from '@/assets/shopper/no-reward-badge.svg';
import { displayCurrencyNoDecimals } from '@/utils/format.utils';
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    currentSavings: number;
    savingsGoal: number;
    rewardAmount: number;
    progress: number;
    minimumThresholdMet?: boolean;
  }>(),
  { minimumThresholdMet: true },
);

const badgeIcon = computed(() => (props.minimumThresholdMet ? AchievedRewardBadge : NoRewardBadge));
const displayReward = computed(() => (props.minimumThresholdMet ? props.rewardAmount : 0));
const totalAmount = computed(() =>
  props.minimumThresholdMet ? props.currentSavings + props.rewardAmount : props.currentSavings,
);
</script>
